import { env } from '@/src/config/env'
import { getLegacyUrl } from '@/src/general/utils/getLegacyUrl'

const parseUrl = (value: string): URL | null => {
  try {
    return new URL(value)
  } catch {
    return null
  }
}

export const isHozanaUrl = (value: string) => {
  const url = parseUrl(value)
  return (
    !!url &&
    [getLegacyUrl('/'), env.EXPO_PUBLIC_WEB_BASE_URL].some((base) => base && url.origin === parseUrl(base)?.origin)
  )
}

export const isAdminUrl = (value: string) => {
  const url = parseUrl(value)

  return (
    !!url &&
    url.origin === parseUrl(getLegacyUrl('/'))?.origin &&
    /^\/(?:(?:fr|en|es|pt|it|pl)\/)?admin(?:\/|$)/.test(url.pathname)
  )
}

// Only routes implemented in src/app may leave the WebView. Unknown legacy pages stay in it.
const nativePaths = [
  /^\/$/,
  /^\/(?:prayer-space|preferences|favorites|leave|contact)$/,
  /^\/intentions(?:\/[^/]+)?$/,
  /^\/intention\/create(?:\/reward|\/[^/]+\/pray)?$/,
  /^\/intention\/[^/]+(?:\/prayers|\/(?:pray|reward)|\/[^/]+\/(?:pray|reward))?$/,
  /^\/publications\/[^/]+(?:\/reward|\/reward\/[^/]+\/pray|\/comment\/[^/]+\/pray)?$/,
  /^\/communities(?:\/[^/]+)?$/,
  /^\/community\/[^/]+(?:\/notifications|\/join(?:\/(?:date|mails|notifications|congrats|next(?:\/[^/]+\/pray)?))?)?$/,
  /^\/settings(?:\/account(?:\/avatars(?:\/\d+)?)?|\/notifications\/(?:general|communities))?$/,
  /^\/messages(?:\/\d+(?:\/\d+\/pray)?)?$/,
  /^\/auth\/(?:email|name|otp|complete)$/,
  /^\/watchman(?:\/reward|\/intentions(?:\/(?:pray|reward|notifications))?)?$/,
  /^\/subscriptions\/history$/,
  /^\/page\/[^/]+$/,
  /^\/rosario\/roses$/,
  /^\/unsubscribe\/donation-mail$/,
]

export const getNativePath = (value: string): string | null => {
  if (!isHozanaUrl(value)) return null
  const url = parseUrl(value)
  if (!url) return null
  let pathname = url.pathname.replace(/^\/(?:fr|en|es|pt|it|pl)(?=\/|$)/, '') || '/'
  pathname = pathname.replace(/\/$/, '') || '/'
  pathname = pathname
    .replace(/^\/(?:intenciones|intencoes)(?=\/|$)/, '/intentions')
    .replace(/^\/(?:intencion|intencao)(?=\/|$)/, '/intention')
    .replace(/^\/(?:publication|publicacion|publicacao)(?=\/|$)/, '/publications')
    .replace(/^\/(?:communaute|comunidad|comunidade)(?=\/|$)/, '/community')
  return nativePaths.some((pattern) => pattern.test(pathname)) ? pathname + url.search + url.hash : null
}
